import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-lg mb-4 bg-white overflow-hidden" data-id="element-4">
      <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-inset" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-5">
        <span className="font-bold text-lg text-gray-900" data-id="element-6">{question}</span>
        {isOpen ? <ChevronUpIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-7" /> : <ChevronDownIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-8" />}
      </button>
      <div className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-9">
        <div className="px-6 pb-4 text-gray-700" data-id="element-10">
          <p data-id="element-11">{answer}</p>
        </div>
      </div>
    </div>;
}
export function FAQAccordion() {
  const faqs = [{
    question: '¿Es material digital?',
    answer: 'Sí. Descarga inmediata.'
  }, {
    question: '¿Necesito gimnasio?',
    answer: 'No.'
  }, {
    question: '¿Sirve si hace años no entreno?',
    answer: 'Sí. Está diseñado para empezar desde cero.'
  }, {
    question: '¿Son solo rutinas?',
    answer: 'No. Es un sistema completo de entrenamiento, nutrición y estructura mental.'
  }, {
    question: '¿Tiene garantía?',
    answer: 'Sí, para ambos'
  }, {
    question: '¿Es para Papa y Mama?',
    answer: 'Sí, para ambos'
  }];
  return <div className="w-full max-w-3xl mx-auto" data-id="element-12">
      {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-13" />)}
    </div>;
}